<header class="flex flex-col w-full safe-top bg-primary">
    <!-- 최상단 헤더 -->
    <section class="flex justify-between items-center px-4 py-2.5 w-full">
        <img
            [draggable]="false"
            class="my-1 transition-all duration-300 ease-in-out cursor-pointer hover:opacity-70"
            [routerLink]="user() ? '/my-child/dashboard' : '/'"
            src="https://kr1-api-object-storage.nhncloudservice.com/v1/AUTH_2355fbddd74e499f89b6640b98832b2c/file-storage/white-logo.svg"
            alt="logo"
        />

        <button class="flex items-center gap-3">
            <div class="relative" (click)="moveToNotification()">
                @if (notificationCount(); as count) {
                    <div
                        class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-red-600 text-white -top-1 -right-2"
                    >
                        @if (count > 99) {
                            99
                        } @else {
                            {{ count }}
                        }
                    </div>
                }
                <app-icon
                    name="solar:bell-bold-duotone"
                    class="text-white opacity-50 !size-7"
                />
            </div>

            @if (!isNativeApp()) {
                <div class="relative" routerLink="/shopping-cart">
                    @if (user()?.shoppingCart?.itemsCount; as count) {
                        <div
                            class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-red-600 text-white -top-1 -right-2"
                        >
                            @if (count > 99) {
                                99
                            } @else {
                                {{ count }}
                            }
                        </div>
                    }
                    <app-icon
                        name="solar:bag-4-bold-duotone"
                        class="text-white opacity-50 !size-7"
                    />
                </div>
            }

            <app-icon
                (click)="handleSidebar()"
                name="material-symbols:menu-rounded"
                class="text-white opacity-50 !size-7"
            />
        </button>
    </section>

    <div class="flex justify-between items-center px-4 pt-2 pb-4">
        @if (
            childStore.children()?.length && childStore.selectedChild$();
            as selectedChild
        ) {
            <div class="flex flex-col gap-3 md:items-center sm:flex-row">
                <div
                    (click)="openModal($event)"
                    class="flex w-fit px-3 py-1.5 items-center rounded-full border border-[#5BB3D9] gap-1 transition-all duration-300 ease-in-out bg-[#32A0D0] cursor-pointer select-none"
                >
                    <p class="font-semibold text-white">
                        {{ selectedChild.name }} 아동
                    </p>
                    <app-icon
                        name="material-symbols:keyboard-arrow-down-rounded"
                        class="text-white opacity-50"
                    />
                </div>
                <div class="flex gap-4 items-center">
                    <p class="text-[#AAE5FF] md:text-base text-sm">
                        {{ Gender[selectedChild.gender] }}
                    </p>
                    <div class="w-px h-4 bg-primary-300"></div>
                    <p class="text-[#AAE5FF] md:text-base text-sm">
                        {{ selectedChild.birth | date: "yyyy.MM.dd" }}
                    </p>
                    <div class="w-px h-4 bg-primary-300"></div>
                    <p class="text-[#AAE5FF] md:text-base text-sm">
                        {{ selectedChild.koreanAge }}
                    </p>
                    @if (guardianInfo()?.relationship) {
                        <div class="w-px h-4 bg-primary-300"></div>
                        <p class="text-[#AAE5FF] md:text-base text-sm">
                            {{ Relationship[guardianInfo()?.relationship!] }}
                        </p>
                    }
                </div>
            </div>
        } @else {
            <a routerLink="/find/find-child" class="text-[#AAE5FF] text-xl"
                >아동을 등록해주세요.</a
            >
        }
        <img
            [draggable]="false"
            (click)="handleSidebar()"
            class="py-1 h-full"
            src="https://kr1-api-object-storage.nhncloudservice.com/v1/AUTH_2355fbddd74e499f89b6640b98832b2c/file-storage/transparent-logo.svg"
            alt="logo"
        />
    </div>
</header>
